module.exports = __webpack_public_path__ + "img/耦合线3.cf0615fc.svg";